module.exports = __webpack_public_path__ + "img/logo_landing_light.4d858c91.png";